import React from "react";
import { Accordion, Spinner, Alert, ListGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";
import Badge from "react-bootstrap/Badge";
import HomeNameBadge from "../../Partials/HomeNameBadge/index.jsx";
import TimestampBadge from "../../Partials/TimestampBadge";
import { useTimezone } from "../../../contexts/TimezoneContext";

function roleBadgeVariant(role) {
    if (role === 'owner') return 'success';
    if (role === 'dealer') return 'warning';
    return 'secondary';
}

function HomesList({ homes = [], selectedHomeId = null, onSelectHome, isLoading = false, error = null }) {
    const { formatDateCustom } = useTimezone();
    return (
        <Accordion defaultActiveKey="Homes" className="sidebarAccordion mb-2" alwaysOpen>
            <Accordion.Item eventKey="Homes">
                <Accordion.Header>
                    <div className="d-flex justify-content-between align-items-center w-100 me-2">
                        <div><FontAwesomeIcon icon={faHouse} className="me-2" />Homes</div>
                        <Badge bg="dark">{homes.length}</Badge>
                    </div>
                </Accordion.Header>
                <Accordion.Body className="p-2">
                    {isLoading ? (
                        <div className="text-center p-3"><Spinner animation="border" size="sm" /></div>
                    ) : error ? (
                        <Alert variant="danger" className="mb-0">Error loading homes: {error}</Alert>
                    ) : homes.length === 0 ? (
                        <div className="text-center text-muted p-2">No homes for this user</div>
                    ) : (
                        <ListGroup>
                            {homes.map((home) => (
                                <ListGroup.Item
                                    key={home.id}
                                    action
                                    active={home.id === selectedHomeId}
                                    onClick={() => onSelectHome(home.id)}
                                    className="d-flex justify-content-between align-items-center"
                                >
                                    <div className="d-flex flex-column align-items-start" style={{ gap: '0.15rem' }}>
                                        <div className="d-flex align-items-center" style={{ gap: '0.25rem' }}>
                                            <HomeNameBadge name={home.name} />
                                            <Badge bg={roleBadgeVariant(home.role)}>{home.role}</Badge>
                                        </div>
                                        <small className="text-muted">{home.home_code}</small>
                                    </div>
                                    <div className="d-flex align-items-center" style={{ gap: '0.25rem' }}>
                                        <Badge bg="dark">{home.bond_count} bonds</Badge>
                                        <Badge bg="secondary">{home.member_count} members</Badge>
                                        {home.created && (
                                            <TimestampBadge
                                                value={home.created}
                                                absolute={formatDateCustom(home.created, 'date')}
                                                label="Created"
                                                bg="light"
                                                text="dark"
                                            />
                                        )}
                                    </div>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
}

export default HomesList;
